// extracted by mini-css-extract-plugin
module.exports = {"icon":"season-image-module--icon--1ljJv"};